/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * TSOA-compatible provider ids for property imports.
 *
 * Keep in sync with the backend provider registry.
 */
export enum TCRealEstateProviderId {
    PROP360 = 'prop360',
    KUTT = 'kutt',
    ILIST = 'ilist',
    GLOBALBROKERS = 'globalbrokers',
}
